export const claimsoorten = [
  {
    value: '.',
    label: 'Zoek claimsoort',
    subLabel: '',
  },
  {
    value: 'BALTO',
    label: 'BALTO',
    subLabel: 'Snelschakelaar vervangen',
  },
  {
    value: 'BUICNG',
    label: 'BUICNG',
    subLabel: 'Back Up ICNG',
  },
  {
    value: 'BUSNG',
    label: 'BUSNG',
    subLabel: 'Backup SNG',
  },
  {
    value: 'CONWYZ',
    label: 'CONWYZ',
    subLabel: 'Gereserveerd t.b.v. CW',
  },
  {
    value: 'DC',
    label: 'DC',
    subLabel: 'Dagelijkse Controle',
  },
  {
    value: 'DCR',
    label: 'DCR',
    subLabel: 'Dagelijkse Controle + reiniging',
  },
  {
    value: 'DCW',
    label: 'DCW',
    subLabel: 'Dagelijkse Controle Water vullen perron',
  },
  {
    value: 'DR',
    label: 'DR',
    subLabel: 'Dagelijkse reiniging',
  },
  {
    value: 'DSTREV',
    label: 'DSTREV',
    subLabel: 'Draaistelrevisie FLIRT',
  },
  {
    value: 'EBK',
    label: 'EBK',
    subLabel: 'Extra binnenkomst',
  },
  {
    value: 'EBKSB',
    label: 'EBKSB',
    subLabel: 'Extra binnenkomst service bedrijf',
  },
  {
    value: 'ERTMS',
    label: 'ERTMS',
    subLabel: 'tbv proefbedrijf ERTMS',
  },
  {
    value: 'EXKOEL',
    label: 'EXKOEL',
    subLabel: 'Na KOELER claim',
  },
  {
    value: 'EXLOND',
    label: 'EXLOND',
    subLabel: 'Uit onderhoud Leidschendam',
  },
  {
    value: 'EXMOND',
    label: 'EXMOND',
    subLabel: 'Uit onderhoud Maastricht',
  },
  {
    value: 'EXOND',
    label: 'EXOND',
    subLabel: 'Stel beschikbaar na onderhoud',
  },
  {
    value: 'EXWOND',
    label: 'EXWOND',
    subLabel: 'Uit onderhoud Watergraafsmeer',
  },
  {
    value: 'F OND',
    label: 'F OND',
    subLabel: 'Facultatief Onderhoud',
  },
  {
    value: 'FAC',
    label: 'FAC',
    subLabel: 'FACULTATIEF',
  },
  {
    value: 'GARANT',
    label: 'GARANT',
    subLabel: 'Garantie stellen tbv nieuw materieel',
  },
  {
    value: 'GDST',
    label: 'GDST',
    subLabel: 'Geen dienst',
  },
  {
    value: 'HIP',
    label: 'HIP',
    subLabel: 'HERINSTRUCTIE PERSONEEL',
  },
  {
    value: 'JBEURT',
    label: 'JBEURT',
    subLabel: 'Jaarbeurt',
  },
  {
    value: 'KOELER',
    label: 'KOELER',
    subLabel: 'Reinigen oliekoeler + remvoering',
  },
  {
    value: 'KWB',
    label: 'KWB',
    subLabel: 'KUIL WIELENBANK',
  },
  {
    value: 'LANGPA',
    label: 'LANGPA',
    subLabel: 'Lang Parkeren Materieel',
  },
  {
    value: 'LEDMAT',
    label: 'LEDMAT',
    subLabel: 'Ledig mat nog niet in dienstregeling',
  },
  {
    value: 'METEN',
    label: 'METEN',
    subLabel: 'wielen meten voor controle',
  },
  {
    value: 'MRC',
    label: 'MRC',
    subLabel: 't.b.v. MRC',
  },
  {
    value: 'MWBX',
    label: 'MWBX',
    subLabel: 'Inwendig reinigen door NSM',
  },
  {
    value: 'NSRRES',
    label: 'NSRRES',
    subLabel: 'Strategische Reserve Prod. Management',
  },
  {
    value: 'NSTEST',
    label: 'NSTEST',
    subLabel: 'test',
  },
  {
    value: 'OBIS',
    label: 'OBIS',
    subLabel: 'Ombouw Informatieschermen',
  },
  {
    value: 'OLIE',
    label: 'OLIE',
    subLabel: 'Inloopolie vervangen',
  },
  {
    value: 'ONB',
    label: 'ONB',
    subLabel: 't.b.v. ONB',
  },
  {
    value: 'OND',
    label: 'OND',
    subLabel: 'Onderhoud',
  },
  {
    value: 'PROJEC',
    label: 'PROJEC',
    subLabel: "Onderhoud van ARA's",
  },
  {
    value: 'RDL',
    label: 'RDL',
    subLabel: 'overbrenging zonder treinnummer',
  },
  {
    value: 'RES',
    label: 'RES',
    subLabel: 'Reserve',
  },
  {
    value: 'RITBKD',
    label: 'RITBKD',
    subLabel: 'Ritclaim Bokkeduinen',
  },
  {
    value: 'RITBKH',
    label: 'RITBKH',
    subLabel: 'Ritclaim Binckhorst',
  },
  {
    value: 'RITGNV',
    label: 'RITGNV',
    subLabel: 'Ritclaim Groningen Vork',
  },
  {
    value: 'RITHNK',
    label: 'RITHNK',
    subLabel: 'Ritclaim Hoorn',
  },
  {
    value: 'RITWGM',
    label: 'RITWGM',
    subLabel: 'Ritclaim Watergraafsmeer',
  },
  {
    value: 'RITWHV',
    label: 'RITWHV',
    subLabel: 'Ritclaim Amsterdam Westhaven',
  },
  {
    value: 'RITWPL',
    label: 'RITWPL',
    subLabel: 'Ritclaim Werkplaats',
  },
  {
    value: 'RMVV',
    label: 'RMVV',
    subLabel: 't.b.v. RayonManager VerVoer',
  },
  {
    value: 'SANVUL',
    label: 'SANVUL',
    subLabel: 'Vullen van Sandite treinstellen',
  },
  {
    value: 'STOEL',
    label: 'STOEL',
    subLabel: 'Renovatie stoelbekleding',
  },
  {
    value: 'STRAND',
    label: 'STRAND',
    subLabel: 't.b.v. strandvervoer',
  },
  {
    value: 'T',
    label: 'T',
    subLabel: 'Tanken',
  },
  {
    value: 'TBKOEL',
    label: 'TBKOEL',
    subLabel: 'Ten behoeve van KOELER',
  },
  {
    value: 'TBLOND',
    label: 'TBLOND',
    subLabel: 'Ten behoeve Leidschendam onderhoud',
  },
  {
    value: 'TBVEBK',
    label: 'TBVEBK',
    subLabel: 'Extra binnenkomst voor herstelwerkzaamheden.',
  },
  {
    value: 'TBVOND',
    label: 'TBVOND',
    subLabel: 'Onderhoudspad MRC',
  },
  {
    value: 'TBVPC',
    label: 'TBVPC',
    subLabel: 'T.b.v. Product Control NS-Hispeed',
  },
  {
    value: 'TBVPRO',
    label: 'TBVPRO',
    subLabel: 'materieel reserveren t.b.v. project',
  },
  {
    value: 'TCB',
    label: 'TCB',
    subLabel: 'Technische controle beurt',
  },
  {
    value: 'THABTL',
    label: 'THABTL',
    subLabel: 'Thalys treinen rijdend in buitenland',
  },
  {
    value: 'VAKANT',
    label: 'VAKANT',
    subLabel: 'Dienst bestaat niet meer',
  },
  {
    value: 'WASSEN',
    label: 'WASSEN',
    subLabel: 'wassen met oxaal',
  },
  {
    value: 'RITLLS',
    label: 'RITLLS',
    subLabel: 'Ritclaim LLSO',
  },
  {
    value: 'ATO',
    label: 'ATO',
    subLabel: 'Automatic Train Operation',
  },
  {
    value: 'TCHRES',
    label: 'TCHRES',
    subLabel: 'Technische reserve O&S',
  },
  {
    value: 'KPREIN',
    label: 'KPREIN',
    subLabel: 'Keerpuntreiniging',
  },
];
const getClaimsoorten = () => {
  return claimsoorten;
};
export default getClaimsoorten;
